module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-13"
  }, [_vm._v("Her personal identity has always been simple enough—"), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("adopted.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Blank slate. Washed clean. No memory.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Very young, not yet three, when she’d been adopted by a (childless, older) couple in St. Paul named Seidel"), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("That was all she’d needed to know about that phase of her life: she’d been adopted at a young age. All she’d wished to know.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A tabula rasa, it is. Adoption.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Her (adoptive) parents did tell her that her birth name was Clare—that is, her name was Clare Ellen when she’d come into their lives, and this was a “very charming” name that they saw no reason to change, as (of course, officially) they would be changing her last name now that she was their little girl.")]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-13"
  }, [_vm._v("A matter of property, possession. A child is delivered to an adult or adults—delivered by birth, sometimes delivered by an agency.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Maybe she’d seen that name—Donegal"), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—")]), _vm._v("on her birth certificate. So long ago, it made no impression on her and (in fact) she has forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Every adoption is a mystery—"), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Why was I given up, given away? Why was I not wanted?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("By whom was I not wanted?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But Clare Seidel was/is the perfect (adopted) daughter. Clare did not/does not ask.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("A grateful child does not ask why.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("The Seidels were older parents. Might’ve been their adopted child’s grandparents. Both were teachers with a mission­—­educators. Over the course of seventeen years of marriage they had not had children, though (Clare has gathered) they’d tried. Not long before Clare was adopted, a beloved dog belonging to the Seidels had died. Clare has seen pictures of this pert, brush-haired Airedale flanked by its adoring master and mistress and has felt a stab of jealousy, fear. (If the Airedale hadn’t passed away at the age of twelve, at precisely the time he did, would the person identified as Clare Seidel"), _c('span', {
    staticClass: "CharOverride-5"
  }), _vm._v("exist?) The Seidels did not wish to think that life had cheated them. They had combined incomes, two cars, a house with a reasonable mortgage. For two weeks each August they rented a cottage on Lake Superior. They were grateful for the orphaned child Clare, as Clare would come to be grateful for them. ")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Don’t hurt Dad’s feelings! Don’t ever make him think he isn’t your Dad, because he ")]), _vm._v("is.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Because there is no other Dad, or Mom, for you. There is—just us.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Instinctively Clare knew. She understood. She was their ­(adopted) little girl who would never ask why.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("For instance, an (adopted) child never asks, "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Why did you want me?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Couldn’t you have children of your own, was that why you’d ­adopted me?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Of course, never ask! Unthinkable.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("An (adopted) child never asks, "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("But where did I come from? To whom did I belong before I was given to you?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Later, in school, Clare felt a swell of pride when the smiling teacher pronounced the very special name that meant her: "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Sei-del.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("Such pleasure it gave her, when at last she could write, to write")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Clare Seidel")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Clare Seidel ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Clare Seidel ")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara"
  }, [_vm._v("in her notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("But all that, that part of her life, her very early life, hardly seems hers any longer.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea23808","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802158017-11.vue
// module id = 96
// module chunks = 0